<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <h1 class="sm:mx-0 mx-4 mb-4 sm:mb-12 text-5xl d-theme-heading-color">Cancelamento de Inscrição de Campanhas por E-mail!</h1>
            <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 text-dark">Estamos quase lá, confirme aqui o cancelamento da sua inscrição, para prosseguir e cancelar o recebimento dessa campanha peço que click no botão abaixo.</p>
            <vs-button :disabled="button" size="large" @click.prevent=check>Confirmar Cancelamento</vs-button>
        </div>
    </div>
</template>
<script>
import customer from '@/http/requests/customer'

export default {
    data() {
      return {
        token: '',
        button: false
      }
    },
    methods: {
      check(){
        customer.check(this.token)
          .then(() => {
            this.button = true
            return this.$vs.notify({
              time: 5000,
              color: 'success',
              title: 'Cancelamento de Inscrição',
              text: 'Sua Inscrição foi cancelada com sucesso'
            });
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    mounted(){
        this.token = this.$route.query.token
    }
}
</script>